module.exports = __webpack_public_path__ + "img/reworked_light.cd7b3c33.svg";